"use client";

// Renderiza documentos legais (Termos de Uso / Política de Cookies / Política
// de Privacidade) consumindo GET /site/legal/{tipo}. Conteúdo vem em markdown.

import { useLangContext } from "../lib/lang-context";
import Markdown from "./markdown";

function formatDate(iso, lang) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const tag = lang === "en" ? "en-US" : lang === "es" ? "es-ES" : "pt-BR";
    return d.toLocaleDateString(tag, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export function LegalDocPage({ doc }) {
  const { t, lang } = useLangContext();
  return (
    <div className="page legal-page">
      <section className="hero shell">
        <div className="meta-row">
          <span>{t("legal_kicker") || "@legal"}</span>
          {doc?.versao != null && (
            <span>
              {(t("legal_version") || "Versão").toString().toUpperCase()}{" "}
              {String(doc.versao)}
            </span>
          )}
        </div>
        <h1>{doc?.titulo}</h1>
        {doc?.publicadoEm && (
          <p className="sub mono" style={{ fontSize: 12 }}>
            {t("legal_published_at") || "Publicado em"}{" "}
            {formatDate(doc.publicadoEm, lang)}
          </p>
        )}
      </section>

      <section className="section shell legal-content">
        <Markdown source={doc?.conteudo ?? ""} />
      </section>
    </div>
  );
}
